import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth.component';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from './components/footer/footer/footer.component';
import { ConfirmDialogComponent } from './components/confirmation/confirm-dialog.component';
import { HeaderComponent } from './components/header/header/header.component';
import { DashboardComponent } from './modules/dashboard/components/dashboard/dashboard.component';
import { provideHttpClient, withInterceptorsFromDi, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ProductsComponent } from './modules/products/components/products/products.component';
import { CONFIGURATION_COMPONENTS } from './components/configuration/configuration.module.component';
import { USERWITHROLE_COMPONENTS } from './components/security/userwithrole.module.component';
import { ANGULAR_MATERIAL_MODULES, ANGULAR_MATERIAL_COMPONENTS } from './angular.material.modules';

import { ConfigurationManagementComponent } from './modules/configurationmanagement/components/configuration.management.component';
import { ConfigurationManagementManageComponent } from './modules/configurationmanagement/components/manage/configuration.management.manage.component';
import { ConfigurationManagementListComponent } from './modules/configurationmanagement/components/list/configuration.management.list.component';
import { RoleClaimsComponent } from './modules/products/components/roleclaims/roleclaims.component';
import { ClaimsListComponent } from './modules/rolemanagement/components/list/claims/claims.list.component';

import { UsersListComponent } from './modules/usermanagement/list/user.list.component';
import { UserRoleManageComponent } from './modules/usermanagement/manage/userrole.manage.component';
import { UnauhorizedComponent } from './modules/unauthorized/unauthorized.component';

import { LoginComponent } from './modules/login/components/login.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { ConsumerListComponent } from './modules/consumer/components/list/consumer-list.component';
import { ConsumerAddEditComponent } from './modules/consumer/components/add-edit/consumer-add-edit.component';
import { StationListComponent } from './modules/station/components/list/station-list.component';
import { StationAddEditComponent } from './modules/station/components/add-edit/station-add-edit.component';
import { TocAddEditComponent } from './modules/trainoperationcompany/components/add-edit/toc-add-edit.component';
import { TocListComponent } from './modules/trainoperationcompany/components/list/toc-list.component';
import { ResetPasswordComponent } from './modules/resetpassword/components/resetpassword.component';
import { VideoListComponent } from './modules/videos/components/list/video-list.component';
import { VideoAddEditComponent } from './modules/videos/components/add-edit/video-add-edit.component';
import { PurgeManagementComponent } from './modules/purge/components/purge-management/purge-management.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        AuthComponent,
        LayoutComponent,
        FooterComponent,
        HeaderComponent,
        DashboardComponent,
        ProductsComponent,
        ANGULAR_MATERIAL_COMPONENTS,
        LoginComponent,
        ConfigurationManagementComponent,
        ConfigurationManagementManageComponent,
        ConfigurationManagementListComponent,
        RoleClaimsComponent,
        ClaimsListComponent,
        UsersListComponent,
        UserRoleManageComponent,
        CONFIGURATION_COMPONENTS,
        USERWITHROLE_COMPONENTS,
        HasPermissionDirective,
        UnauhorizedComponent,
        ConfirmDialogComponent,
        ConsumerListComponent,
        ConsumerAddEditComponent,
        StationListComponent,
        StationAddEditComponent,
        TocAddEditComponent,
        TocListComponent,
        ResetPasswordComponent,
        VideoListComponent,
        VideoAddEditComponent,
        PurgeManagementComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ...ANGULAR_MATERIAL_MODULES,
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          })
    ],
    providers: [
      provideHttpClient(withInterceptorsFromDi()),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      }
    ] 
  })
export class AppModule { }
